import { isProdHost, isPreviewHost } from "./env";

// На прод-доменах — prod (env может переопределить), в остальных — всегда test
export const API_BASE =
  isProdHost && !isPreviewHost
    ? process.env.REACT_APP_API_BASE || "https://kassa.ktsf.ru/api/prod"
    : "https://kassa.ktsf.ru/api/test";

export const BASE_URL = "https://kassa.ktsf.ru";

// на время отладки можно оставить:
console.log("API_BASE →", API_BASE, "host →", window.location.hostname);
